import {sendToBackgroundViaRelay} from '@plasmohq/messaging';
import {useCallback, useEffect} from 'react';
import {useLocalStorage} from 'react-use';
import {useUserAgent} from './useUserAgent';

const getExtensionVersion = async () => {
  return new Promise((resolve, reject) => {
    sendToBackgroundViaRelay<unknown, chrome.tabs.Tab[] | string>({
      // @ts-expect-error
      name: 'version',
    })
      .then(resolve)
      .catch(reject);
    setTimeout(reject, 200);
  });
};

type PlatformStatus = 'loading' | 'installed' | 'available' | 'not-available';

export function useAppPlatform() {
  const {isAvailableBrowser, isDesktop, isAvailableWindows} = useUserAgent();

  const [windowsStatus, setWindowsStatus] = useLocalStorage<PlatformStatus>(
    'blesk:windows',
    'loading',
  );

  useEffect(() => {
    if (windowsStatus === 'loading' || isAvailableWindows) {
      if (isAvailableWindows) {
        setWindowsStatus('available');
      } else {
        setWindowsStatus('not-available');
      }
    }
  }, [setWindowsStatus, windowsStatus, isAvailableWindows]);

  const [extensionStatus, setExtensionStatus] = useLocalStorage<PlatformStatus>(
    'blesk:extension',
    'loading',
  );

  const handleCheckExtension = useCallback(() => {
    if (isAvailableBrowser && isDesktop) {
      getExtensionVersion()
        .then(() => {
          setExtensionStatus('installed');
        })
        .catch(() => {
          setExtensionStatus('available');
        });
    } else {
      setExtensionStatus('not-available');
    }
  }, [isAvailableBrowser, isDesktop, setExtensionStatus]);

  useEffect(() => {
    setTimeout(() => {
      handleCheckExtension();
    }, 500);
  }, [handleCheckExtension]);

  useEffect(() => {
    window.addEventListener('focus', handleCheckExtension);
    return () => window.removeEventListener('focus', handleCheckExtension);
  }, [handleCheckExtension]);

  return {extensionStatus, windowsStatus, setWindowsStatus};
}
